export default {
    root: {
        class: [
            // Sizing & Visibility
            'tw',
            'tw-w-80 xs:tw-w-96',
            'tw-opacity-90',
            // Layering
        ],
        style: {
            maxWidth: '20rem',
            width: '100%',
            opacity: '0.9',
            zIndex: 1050,
        },
    },
    message: function (_a) {
        var _b, _c, _d, _e;
        var props = _a.props;
        return ({
            class: [
                // Layout & Shape
                'tw-my-4 tw-rounded-md tw-w-full tw-shadow-lg',
                // Borders & Separation
                'tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-border-solid tw-border-0 tw-border-l-4',
                // Background
                'tw-bg-white dark:tw-bg-zinc-700',
                // Severity colors
                {
                    'tw-border-blue-500 tw-text-blue-600 dark:tw-text-blue-400': ((_b = props.message) === null || _b === void 0 ? void 0 : _b.severity) == 'info',
                    'tw-border-green-500 tw-text-green-600 dark:tw-border-green-600 dark:tw-text-green-500': ((_c = props.message) === null || _c === void 0 ? void 0 : _c.severity) == 'success',
                    'tw-border-orange-500 tw-text-orange-600 dark:tw-border-orange-600 dark:tw-text-orange-500': ((_d = props.message) === null || _d === void 0 ? void 0 : _d.severity) == 'warn',
                    'tw-border-red-500 tw-text-red-600 dark:tw-border-red-400': ((_e = props.message) === null || _e === void 0 ? void 0 : _e.severity) == 'error',
                },
            ],
        });
    },
    messagecontent: {
        class: [
            // Layout & Spacing
            'tw-flex tw-items-center tw-py-4 tw-px-6 tw-gap-x-1',
        ],
    },
    messageicon: {
        class: [
            // Sizing
            'tw-w-6 tw-h-6',
            // Styling & Positioning
            'tw-text-lg tw-mr-2',
            'empty:tw-hidden',
        ],
    },
    messagetext: {
        class: [
            // Typography
            'tw-text-base tw-font-sans tw-font-normal',
            // Layout & Flex Behavior
            'tw-flex tw-flex-col tw-flex-1 tw-grow tw-shrink',
            // Coloring
            'tw-text-gray-950 dark:tw-text-gray-50',
        ],
    },
    // summary: 'tw-font-bold tw-block',
    detail: 'tw-block',
    closebutton: {
        class: [
            // Sizing & Shape
            'tw-w-8 tw-h-8 tw-rounded-full tw-bg-transparent',
            // Animation & Transition
            'tw-transition tw-duration-200 tw-ease-in-out',
            // Placement
            'tw-ml-auto tw-overflow-hidden tw-relative',
            // Layout & Alignment
            'tw-flex tw-items-center tw-justify-center',
            // Color & Interaction
            'tw-text-gray-900 hover:tw-text-gray-700 dark:tw-text-gray-100 dark:hover:tw-text-gray-300',
        ],
    },
    transition: {
        enterFromClass: 'tw-opacity-0 tw-translate-x-0 tw-translate-y-2/4 tw-translate-z-0',
        enterActiveClass: 'tw-transition-transform tw-transition-opacity tw-duration-300',
        leaveFromClass: 'tw-max-h-40',
        leaveActiveClass: 'tw-transition-all tw-duration-500 tw-ease-in',
        leaveToClass: 'tw-max-h-0 tw-opacity-0 tw-mb-0 tw-overflow-hidden',
    },
};
